import React from "react";

const DifficultiesFaced = () => {
  const difficulties = [
    {
      category: "MALPRACTICE AND CORRUPTION",
      reason: "Leaking question papers, accepting bribes, or manipulating results",
    },
    {
      category: "INCOMPETENCE AND MISMANAGEMENT",
      reason: "Technical glitches, errors in question papers, or mismanagement of exam centers",
    },
    {
      category: "VIOLATION OF GUIDELINES AND REGULATIONS",
      reason: "Repeatedly violates the guidelines and regulations set by the governing bodies or fails to adhere to the prescribed standards",
    },
    {
      category: "LACK OF TRANSPARENCY",
      reason: "Not providing clear guidelines, not disclosing the evaluation process, or not addressing candidates' concerns",
    },
    {
      category: "SECURITY BREACHES",
      reason: "Mishandling sensitive data or experiencing data breaches",
    },
    {
      category: "REPEAT OFFENDER",
      reason: "Agency has a history of repeated misconduct or involvement in unethical practices",
    },
  ];

  return (
    <div className="container py-5" style={{marginTop:"60px"}}>
      {/* Heading Section */}
      <div className="text-center mb-5">
        <h2 className="display-5 fw-bold text-center text-danger title split-collab mb-30" >
          Difficulties Faced by Agencies in Operation
        </h2>
        <hr style={{ width: "100px", border: "2px solid #ff0000", margin: "25px auto" }} />
      </div>

      {/* Difficulty Cards */}
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4"
        data-sal-delay="150"
        data-sal="slide-up"
        data-sal-duration="800"
      >
        {difficulties.map((item, index) => (
          <div key={index} className="col">
            <div
              className="card h-100 p-3"
              style={{
                backgroundColor: "#fff",
                border: "1px solid #ff0000",
                borderRadius: "15px",
                boxShadow: "0 4px 12px rgba(255, 0, 0, 0.1)",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div className="card-body text-center">
                <h5
                  className="card-title fw-bold text-danger"
                  style={{
                    background: "linear-gradient(to bottom, #fff, #ffebee)",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                >
                  {item.category}
                </h5>
                <p className="card-text mt-3" style={{ color: "#333",fontSize:"16px", fontWeight:"400" }}>
                  {item.reason}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DifficultiesFaced;